<script setup lang="ts">
/* One inline SVG from the sprite in `icons.ts`. Strokes only, so it
   inherits `currentColor` and scales cleanly. */
import { iconPaths } from './icons'
import type { IconName } from './icons'

withDefaults(
  defineProps<{
    name: IconName
    /** Rendered size in px. */
    size?: number
    strokeWidth?: number
    /**
     * Accessible label. Omit for decorative icons (the default) — the
     * icon is then hidden from assistive technology.
     */
    title?: string
  }>(),
  { size: 20, strokeWidth: 1.75 },
)
</script>

<template>
  <svg
    viewBox="0 0 24 24"
    :width="size"
    :height="size"
    fill="none"
    stroke="currentColor"
    :stroke-width="strokeWidth"
    stroke-linecap="round"
    stroke-linejoin="round"
    :role="title ? 'img' : undefined"
    :aria-hidden="title ? undefined : true"
    :aria-label="title"
    focusable="false"
  >
    <path :d="iconPaths[name]" />
  </svg>
</template>
